import Icon from './Icon'
import Table from './Table'
import TableColumn from './TableColumn'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class SetupParticipantsPageExpandedRow extends PureComponent {
  static propTypes = {
    assignments: PropTypes.array.isRequired
  }

  renderResponseTypes(responseTypes) {
    return responseTypes.map(
      responseType =>
        responseType !== 'none' && (
          <Icon
            title={responseType.tooltip}
            key={responseType.code}
            name={responseType.code}
            className="marginRight5"
          />
        )
    )
  }

  render() {
    const { assignments } = this.props

    return (
      <tr className="table-expanded-row">
        <td colSpan={2} />
        <td colSpan={6}>
          <Table data={assignments}>
            <TableColumn dataKey="title" label="Assignment" />
            <TableColumn dataKey="responseCount" label="Responses" />
            <TableColumn dataKey="responseTime" label="Video Duration" />
            <TableColumn
              align="right"
              cellRenderer={this.renderResponseTypes}
              dataKey="responseTypes"
              label="Response Types"
            />
          </Table>
        </td>
        <td />
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/SetupParticipantsPageExpandedRow.js